import logIOS from './logIOS';
import runIOS from './runIOS';
import buildIOS from './buildIOS';

export default [logIOS, runIOS, buildIOS];
